// extracted by mini-css-extract-plugin
export default {"warning":"_827F7"};